import axios from 'axios';
import { getCsrftoken } from '../../helpers/csfrToken';
import { restErrorHandler } from '../../helpers/restErrorHandler';
import { RestApiState } from './Organization';

export type ChoicesProps = {
    value: number | undefined | string;
    label: string;
}


export type Responsible = {
    username: string;
    full_name: string;
}


export type CommisionProps = {
    created_at: string;
    voltage?: number;
    nominal_capacity?: number;
    weight?: number;
    comment?: string,
    size?: string;
    is_cooling_activity?: boolean;
    is_heating_activity?: boolean;
    is_default_activity?: boolean; 
    is_waterproof_activity?: boolean;
    sku?: string;
    chemistry?: number;
    elements?: number;
    batch_code?: string;
    contactors?: number; 
    model_name?: number; 
    cycle_capacity?: number;
    documentation?: string;
    bms_hw_version?: string;
    bms_model?: string;
    chemistry_choices: ChoicesProps[];
    model_name_choices: ChoicesProps[];
    image_choices: ChoicesProps[];
    contactors_choices: ChoicesProps[];
    elements_choices: ChoicesProps[];
    is_commissioned?: boolean;
    responsible?: Responsible;
    image?: number
}


export const fetchCommissionData = (serialNumber: string, role: string, setData: (value: CommisionProps) => void): void => {
    axios.get<CommisionProps>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/commission`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            var data: CommisionProps = response.data
            setData(data)
        }
    })
    .catch(error => {
        restErrorHandler(error.status)
    });
}


export const updateCommissionData = (serialNumber: string, role: string, data: any, statusSetter: (value: RestApiState) => void): void => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }
    axios.put<CommisionProps>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/commission`, data , headers)
        .then(response => {
                if (response.status === 200) {
                    statusSetter(RestApiState.Success)
                }
            }
        )
        .catch(error => {
            console.error('Error fetching accumulator details:', error)
            if (error.response.status === 400) {
                statusSetter(RestApiState.BadRequest)
            } else if (error.response.status === 500) {
                statusSetter(RestApiState.ServerError)
            } else {
                statusSetter(RestApiState.Unknown)
            }
        });
}


export const approveCommissionData = (serialNumber: string, role: string, statusSetter: (value: RestApiState) => void): void => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }
    axios.post<any>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/commission-approve`, {},headers)
        .then(response => {
                if (response.status === 200) {
                    statusSetter(RestApiState.Success)
                }
            }
        )
        .catch(error => {
            console.error('Error fetching accumulator details:', error)
            if (error.response.status === 400) {
                statusSetter(RestApiState.BadRequest)
            } else if (error.response.status === 500) {
                statusSetter(RestApiState.ServerError)
            } else {
                statusSetter(RestApiState.Unknown)
            }
        });
}


export type CommisionCommentProps = {
    comment?: string,
}


export const updateCommissionComment = (serialNumber: string, role: string, data: any, statusSetter: (value: RestApiState) => void): void => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }
    axios.put<CommisionCommentProps>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/commission-comment`, data , headers)
        .then(response => {
                if (response.status === 200) {
                    statusSetter(RestApiState.Success)
                }
            }
        )
        .catch(error => {
            console.error('Error fetching accumulator details:', error)
            if (error.response.status === 400) {
                statusSetter(RestApiState.BadRequest)
            } else if (error.response.status === 500) {
                statusSetter(RestApiState.ServerError)
            } else {
                statusSetter(RestApiState.Unknown)
            }
        });
}